import type { UploadStandardKey } from "@/core/components/upload-wizard";

const escapeCSV = (v: string): string =>
	/[",\n]/.test(v) ? `"${v.replaceAll('"', '""')}"` : v;

export interface DownloadImportTemplateOptions {
	/** Only emit mandatory columns (drop the optional ones). */
	mandatoryOnly?: boolean;
	/** Emit the second "mandatory/optional" guidance row. */
	withGuidanceRow?: boolean;
}

export function downloadImportTemplate(
	filename: string,
	standardKeys: UploadStandardKey[],
	opts: DownloadImportTemplateOptions = {},
): void {
	const { mandatoryOnly = false, withGuidanceRow = true } = opts;
	const keys = mandatoryOnly
		? standardKeys.filter((k) => k.required || k.includeInTemplate)
		: standardKeys;
	const headers = keys.map((k) => escapeCSV(k.label));
	let csv = `${headers.join(",")}\n`;
	// Guidance row (mandatory/optional) mirrors the reference template. Delete it
	// before filling in real data — if left in, the import flags it as an invalid
	// row rather than creating a bogus record.
	if (withGuidanceRow) {
		const notes = keys.map((k) =>
			escapeCSV(k.templateNote ?? (k.required ? "mandatory" : "optional")),
		);
		csv += `${notes.join(",")}\n`;
	}
	const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
}
